import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { View, Text, Platform } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import styles from '@stylesheet';
import SocketManager from '@utils/socket';
import AnimatedTextFunction from '@hooks/animateTextEntry';
import * as Animatable from 'react-native-animatable';
import Counter from '@hooks/counter';
import useGlobalUser from '@hooks/getGlobalUser';
import CountUp from 'react-countup';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import { useSelector } from 'react-redux';
import { DefaultRootState } from '@reduxLocal/persistState';

const socketManager = new SocketManager('data');

type DataCounterTypes = {
  refreshCallback: Function,
  dataCount: number,
  dataId?: string,
  extraCount?: number,
  props: any,
  style?: any
}

const DataCounter = ({ refreshCallback, dataCount, dataId, extraCount, style, props }: DataCounterTypes) => {
  const [dynamicText, setDynamicText] = useState();
  const [showAnimatedText, setShowAnimatedText] = useState(false); // To control when to show the animated text
  const authenticated = useSelector((state: DefaultRootState) => state.promiseData?.isAuthenticated || false);
  const user = useGlobalUser();
  const socket = socketManager.getSocket(user);
  const theme = themeSelector();

  useEffect(() => {
    // Only connect socket if user is authenticated
    if (authenticated && user) {
      socket.connect();
      socket.emit('new user');
    }
    
    setTimeout(() => {
      setShowAnimatedText(true);
    }, 2000); // 2000 milliseconds (2 seconds)
    
    return () => {
      if (socket.connected) {
        socketManager.disconnect();
      }
    };
  }, [authenticated, user]);

  const callback = useCallback(() => { refreshCallback() }, [])

  const eventHandler = useCallback((event) => {
    setDynamicText(event);
    callback();
  }, [])

  useEffect(() => {
    socket.on("event", eventHandler)
  }, [socket])

  return (
    <View style={[styles.extraSearchBarComponents, { ...style, backgroundColor: theme ? "white" : "#333333", minWidth: 150}]}>
      <View style={[styles.centerEverything, { flex: 1, flexDirection: 'row', }]}>
          {/* {
            dynamicText && showAnimatedText &&
          <Animatable.View useNativeDriver  animation={'slideInUp'} style={{ flex: 5 }}>
              <AnimatedTextFunction speed={100} key={dynamicText?._id?.data} value={dynamicText?.operationType || ""} fontSize={20} />
        </Animatable.View>
        } */}
        <View style={{ flex: 1, flexDirection: 'row', gap: 10, alignSelf: 'flex-end', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
          {
            Platform.OS === 'web' &&
            <CountUp style={{ fontWeight: 'bold', fontFamily: 'sans-serif', color: dataCount > 3 ? 'red' : undefined }} end={dataCount} duration={5} />
          }
          <Ionicons name="folder" size={Platform.OS != 'web' ? 18 : 24} color="blue" />
        </View>
        <View style={{ flex: 1, flexDirection: 'row', gap: 10, alignSelf: 'flex-end', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
          {
            Platform.OS === 'web' && extraCount &&
            <CountUp style={{ fontWeight: 'bold', fontFamily: 'sans-serif', color: extraCount > 300 ? 'red' : undefined }} end={extraCount} duration={5} />
          }
          <Ionicons name="documents" size={Platform.OS != 'web' ? 18 : 24} color="rgb(90,192,234)" />
        </View>
      </View>
    </View>
  )
}
export default DataCounter;